import { ButtonHTMLAttributes, FC } from 'react'
import clx from '../util/clx'
import React from 'react'

type ButtonGroupOption = {
	name: string
	content: React.ReactNode
	buttonProps?: ButtonHTMLAttributes<HTMLButtonElement>
}

type Props = {
	name: string
	selectedOptionName: string
	onChange: (optionName: string) => void
	options: ButtonGroupOption[]
}

const ButtonGroup: FC<Props> = props => {
	const { name, selectedOptionName, options, onChange } = props
	const cl = clx('button-group', `button-group--${name}`)

	return (
		<div className={cl}>
			{options.map(option => {
				const { name, content, buttonProps } = option
				const cl = clx(
					'button-group__button',
					`button-group__button--${name}`,
					{
						'button-group__button--active': selectedOptionName === name,
					},
					buttonProps?.className
				)

				return (
					<button {...option.buttonProps} className={cl} onClick={() => onChange(name)}>
						{content}
					</button>
				)
			})}
		</div>
	)
}

export default ButtonGroup
